const setChoice = (data) => async (dispatch) => {
  dispatch({
    type: "SET_CHOICE",
    payload: data,
  });
};

export default setChoice;
